import axios from './_nestAxios'

export const actualizar = (_id, data) => axios.put(`/glosas-contabilidad/${_id}`, data)
export const get = _id => axios.get(`/glosas-contabilidad/${_id}`)
export const getInfo = _id =>
  axios.get(`/glosas-contabilidad/${_id}`, {
    params: {
      tipoConsulta: 'info'
    }
  })

export const getSelect = idSocio =>
  axios.get('/glosas-contabilidad', { params: { tipoConsulta: 'select', idSocio: idSocio } })

export const getSelectSinSocio = () =>
  axios.get('/glosas-contabilidad', { params: { tipoConsulta: 'select-sin-socio' } })

export const nuevo = data => axios.post('/glosas-contabilidad', data)
export const eliminar = _id => axios.delete(`/glosas-contabilidad/${_id}`)
